import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { AdminService } from '../../admin.service';
import { TicketsComponent } from '../tickets.component';
interface DialogData {}

@Component({
  selector: 'app-add-comment',
  templateUrl: './add-comment.component.html',
  styleUrls: ['./add-comment.component.scss']
})
export class AddCommentComponent implements OnInit {
  ticketData: any;
  commentsList: any;
  comments: string;
  showLoader: boolean;
  constructor(private adminService: AdminService, private toastr: ToastrService, private dialogRef: MatDialogRef<TicketsComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  ngOnInit(): void {
    this.ticketData = this.data["data"];
    this.getCommentsList();
  }

  getCommentsList() {
    this.adminService.getTicketsComment(this.ticketData).subscribe((response:any)=>{      
      this.commentsList = response.comments;
    });    
  }

  postComment() {
    this.showLoader = true;
    let reqobj = {
      "ticket_id": this.ticketData,
      "comment": this.comments
    }
    this.adminService.addComments(reqobj).subscribe((response:any)=>{      
      if(response.message == 'Ticket comment created successfully') {
        this.showLoader = false;
        this.toastr.success(response.message, 'Success');
        this.comments = '';        
        this.getCommentsList();
      }      
    }); 
  }

  close() {
    this.dialogRef.close()
  }

}
